/* eslint-disable */
import SockJS from 'sockjs-client';
import Stomp from 'stompjs';

let nowDate;
let nextDate = new Date();
let diffSecond;
let countConnection = 0;

const webSocketInit = () => {
  return new Promise((resolve) => {
    const accessToken = sessionStorage.getItem('accessToken');
    const domain = window._env_.REACT_APP_API_URL;
    const url = `${domain.replace('rga', 'webSocket')}?access_token=${accessToken}`;
    const sock = new SockJS(url);
    window['stompClient'] = Stomp.over(sock);
    window['stompClient'].heartbeat.outgoing = 30000;
    window['stompClient'].heartbeat.incoming = 30000;
    window['stompClient'].connect({}, function(){
      countConnection = 0;
      resolve();
    }, function () {
      nowDate = new Date();
      diffSecond = parseInt(parseInt(nowDate - nextDate) / 1000);
      countConnection += 1;
      if (countConnection > 3 && diffSecond < 20) {
        window['stompClient'].disconnect();
      } else {
        setTimeout(function() {
          window['stompClient'].disconnect();
          // reconnect
          webSocketInit();
        }, 5000);
        nextDate = new Date();
      }
    });
  })
}

const subscribeNotification = (callback) => {
  window['stompClient'].unsubscribe();
  window['stompClient'].subscribe(`/user/queue/msg`, function (res) {
    callback(res);
  });
}

const disconnect = () => {
  window['stompClient'].disconnect();
}

export {
  webSocketInit, subscribeNotification, disconnect,
}